import * as React from "react"

const ClickyTracker = () => (
  <div className="center">
    <a title="GDPR-compliant Web Analytics" href="https://clicky.com/101361574">
      <img
        alt="Clicky"
        src="//static.getclicky.com/media/links/badge.gif"
        border="0"
      />
    </a>
    <script async src="//static.getclicky.com/101361574.js"></script>
    <noscript>
      <p>
        <img alt="Clicky" width="1" height="1" src="" />
      </p>
    </noscript>
  </div>
)

export default ClickyTracker
